export const createManifest = () => {
  const isRunFromHomescreen = window.matchMedia(
    "(display-mode: standalone)"
  ).matches;

  if (!isRunFromHomescreen) {
    const trimmedPath = window.location.pathname.substring(1);
    const extractedDomain = trimmedPath.substring(0, trimmedPath.indexOf("/"));
    const entryPoint = `${window.location.origin}/${
      extractedDomain.length > 0 ? extractedDomain + "/" : ""
    }login`;
    const manifest = {
      short_name: "Curves",
      name: extractedDomain.length === 0 ? "Curves On The Go" : "Curves 24-7",
      icons: [
        {
          src: `${window.location.origin}/favicon.ico`,
          type: "image/x-icon",
          purpose: "any maskable",
        },
        {
          src: `${window.location.origin}/images/icon-192x192.png`,
          type: "image/png",
          sizes: "192x192",
          purpose: "any maskable",
        },
        {
          src: `${window.location.origin}/images/icon-512x512.png`,
          type: "image/png",
          sizes: "512x512",
          purpose: "any maskable",
        },
        {
          src: `${window.location.origin}/images/icon-144x144.png`,
          type: "image/png",
          sizes: "144x144",
          purpose: "any maskable",
          id: entryPoint,
        },
      ],
      start_url: entryPoint,
      display: "standalone",
      theme_color: "#083535",
      background_color: "#ffffff",
    };
    const stringManifest = JSON.stringify(manifest);
    const blob = new Blob([stringManifest], { type: "application/json" });
    const manifestURL = URL.createObjectURL(blob);
    document.querySelector("#manifest")!.setAttribute("href", manifestURL);
  }
};
